import React from 'react';
import robotImage from '../../assets/robot.svg'; 

const HeroSection = ({ scrollToSection }) => {
  return (
    <section id="inicio" className="min-h-screen flex items-center bg-[#1F1753] relative overflow-hidden">
      <div className="container p-8">
        <div className="flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 xl:ps-10">
            <h1 className="font-['ZenDots'] text-3xl/normal ps-2 md:text-5xl/[1.2] lg:text-5xl/[1.2] xl:text-6xl/normal">
              <span className="text-white">
                Somos uma <span className="text-[#A6FF00]">Empresa de Desenvolvimento de Apps</span> com Soluções<br/> Rápidas e Escaláveis
              </span>
            </h1>
            <p className="font-semibold text-2xl text-white/90 mt-8 mb-10 text-left">É isso que você procura?</p>
            <div className="flex justify-start mt-8">
              <a
                href="/forms"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="bg-[#C6FF00] text-[#151342] px-8 py-4 rounded-full text-xl lg:text-2xl font-semibold hover:bg-[#151342] hover:text-[#C6FF00] border-2 border-[#C6FF00] transition-colors duration-300 hover:scale-105 animate-pulse-border"
                >
                  Comece agora
                </button>
              </a>
            </div>
          </div>
          <div className="absolute hidden lg:block right-0 top-1/2 -translate-y-1/2 w-[50%] h-full flex items-center justify-end">
            <img 
              src={robotImage} 
              alt="Biancode Robot" 
              className="w-[100%] h-auto scale-100 object-contain translate-x-[30%]"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
